import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/git_icon.svg'
import _imports_1 from '../assets/site_icon.svg'


const _hoisted_1 = { class: "list_body" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "list_txt" }
const _hoisted_5 = { class: "btn_section" }
const _hoisted_6 = { class: "btn_wrap" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "taptit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "list_item",
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('parent',_ctx.project)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.project.project_thumnail)
        ? (_openBlock(), _createElementBlock("figure", _hoisted_2, [
            _createElementVNode("img", {
              src: require(`../assets/${_ctx.project.project_thumnail}`),
              alt: _ctx.project.project_name
            }, null, 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.project.project_name), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => {$event.stopPropagation();}),
              href: _ctx.project.github_url,
              target: "_blank"
            }, _cache[3] || (_cache[3] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "깃허브 바로가기"
              }, null, -1)
            ]), 8, _hoisted_7),
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => {$event.stopPropagation();}),
              href: _ctx.project.site_url,
              target: "_blank"
            }, _cache[4] || (_cache[4] = [
              _createElementVNode("img", {
                src: _imports_1,
                alt: "사이트 바로가기"
              }, null, -1)
            ]), 8, _hoisted_8)
          ])
        ]),
        _createElementVNode("p", null, _toDisplayString(_ctx.project.project_summary), 1),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _cache[5] || (_cache[5] = _createElementVNode("em", null, "개발 환경", -1)),
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.project.development_environment, (item, idx) => {
                return (_openBlock(), _createElementBlock("span", { key: idx }, _toDisplayString(item), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("li", null, [
            _cache[6] || (_cache[6] = _createElementVNode("em", null, "개발 기간", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.project.development_period.date) + "(" + _toDisplayString(_ctx.project.development_period.duration_weeks) + "주)", 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("i", null, _toDisplayString(_ctx.project.project_type), 1)
    ])
  ]))
}